// components
import Header from "./header_mobile";
import Footer from "./footer_mobile";
import Error from "../../components/error";
import Ready from "../../components/ready";
import UserListMobile from "./userList/userList_mobile";
import HelpMobile from "./userList/help_mobile";
import UserInfoMobile from "./userInfo/userInfo_mobile";
import LocationMobile from "./location/location_mobile";
import UserDetailMobile from "./userInfo/userDetail_mobile";
import UserMonitorMobile from "./userInfo/userMonitor_mobile";
import AccountMobile from "./account/account_mobile";
import NotiLogMobile from './noti/notiLog_mobile';
import AddMobile from './add/add_mobile';
import UpdateMobile from "./update/update_mobile";
import PlacePhotoMobile from "./userInfo/placePhoto_mobile";
import ChangePhotoMobile from "./userInfo/changePhoto_mobile";

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";

// css
import styles from "./main_mobile.css";

// services
import { authGuest, setDelToken, setToken, isLogin, getUser, delAdmToken } from "../../service/authService";
import { getAccountInfo } from "../../service/mngt/accoutMngtService";
import { setLocation } from "../../service/log/locationLogService";
import NotiLogDetailMobile from './noti/notiLogDetail_mobile';

function ContentsMobile({ conn, codeList, rgnList, dongList, loginStatus, setUpdateLoginStatus }) {

  const { kakao } = window;

  document.body.style.backgroundColor = "#fff";

  const location = useLocation();
  const history = useHistory();
  const userInfo = getUser();

  const preventClose = (e) => {
    // e.preventDefault();
    delAdmToken(conn, getUser().userId);
  };

  const [dataState, setDataState] = useState({
    userId: userInfo.userId,
    lat: null,
    lng: null,
  })

  // 현재 조회한 대상자 전화번호 설정
  const [state, setState] = useState([]);
  
  if (location.pathname === "/") {
    if(userInfo.userTypeCode === 2001 || userInfo.userTypeCode === 2006) {
      history.push({
        pathname: "/user/info",
      });
    } else {
      history.push({
        pathname: "/user/list",
      });
    }
  }

  const getAddr = (lat,lng) => {
    // 주소-좌표 변환 객체를 생성합니다
    let geocoder = new kakao.maps.services.Geocoder();

    let coord = new kakao.maps.LatLng(lat, lng);
    let callback = function(result, status) {
        if (status === kakao.maps.services.Status.OK) {
            const arr  ={ ...result};
            const _arr = arr[0].address.address_name;
            setDataState(dataState => {
              const item = { ...dataState };
              item.lat = lat;
              item.lng = lng;
              item.address = _arr;
              setLocation(conn, item);
              return item;
            })
        }
    }
    geocoder.coord2Address(coord.getLng(), coord.getLat(), callback);
  }

  useEffect(() => {

    // window.addEventListener("beforeunload", preventClose);

    getAccountInfo(conn, userInfo)
      .then(response => {
        if(response.personalInformationConsentYn === "N") {
          setDelToken();
          setUpdateLoginStatus(false);
        } 
      })
      .catch(err => {
        console.log("getAccountInfo err = ", err);
      })

    // 대상자면 30분마다 위도, 경도 저장
    // if(userInfo.userTypeCode === 2001) {

    //   if ("geolocation" in navigator) {
    //     navigator.geolocation.getCurrentPosition((position) => {
    //       getAddr(position.coords.latitude, position.coords.longitude)
    //     }, (error) => {
    //       console.error("Error getting location:", error);
    //     });
    //   } else {
    //     console.log("Geolocation is not supported by this browser.");
    //   }

    //   const interval = setInterval(() => {
    //     if ("geolocation" in navigator) {
    //       navigator.geolocation.getCurrentPosition((position) => {
    //         getAddr(position.coords.latitude, position.coords.longitude)
    //       }, (error) => {
    //         console.error("Error getting location:", error);
    //       });
    //     } else {
    //       console.log("Geolocation is not supported by this browser.");
    //     }
    //   }, 30 * 60 * 1000); // 30 minutes in milliseconds

    //   // Clean up the interval on component unmount
    //   return () => {
    //     clearInterval(interval);
    //   };
    // }

  }, [])

  return (
    <>
      <Header conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus} state={state}/>
      <Switch>
        <Route exact path="/error" render={() => <Error conn={conn} />} />
        <Route exact path="/ready" render={() => <Ready conn={conn} />} />
        <Route exact path="/user/list" render={() => <UserListMobile conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus} rgnList={rgnList} dongList={dongList}/>} />
        <Route exact path="/user/info" render={() => <UserInfoMobile conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus} setState={setState}/>} />
        <Route exact path="/user/location" render={() => <LocationMobile conn={conn} />} />
        <Route exact path="/add" render={() => <AddMobile conn={conn} />} />
        <Route exact path="/update" render={() => <UpdateMobile conn={conn} />} />
        <Route exact path="/user/info/detail" render={() => <UserDetailMobile conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus} />} />
        <Route exact path="/user/info/monitor" render={() => <UserMonitorMobile conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus} />} />
        <Route exact path="/user/info/placePhoto" render={() => <PlacePhotoMobile conn={conn} />} />
        <Route exact path="/account" render={() => <AccountMobile conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus}/>} />
        <Route exact path="/help" render={() => <HelpMobile conn={conn} />} />
        <Route exact path="/notiLog" render={() => <NotiLogMobile conn={conn} />} />
        <Route exact path="/notiLogDetail" render={() => <NotiLogDetailMobile conn={conn} />} />
        <Route exact path="/user/info/changePhoto" render={() => <ChangePhotoMobile conn={conn} />} />
      </Switch>
      <Footer conn={conn}/>
    </>
  );
}

export default ContentsMobile;
